import { h } from 'preact';
import React, { Component } from 'react';
import Toggle from '../Components/Toggle';
import Switch from '../Components/Switch';
import { makeText, formatDescription } from '../../../util';

export default class StackToggle extends Component {
  state = {
    open: false,
    consentAll: false,
    liAll: false,
    disclosureAll: false,
    vendorsAll: false
  }
  toggleAccordion = e => {
    const content = this.content;
    const open = !this.state.open;
    this.setState({ open }, this.props.force);
    if (!open) {
      content.style.maxHeight = null;
    } else {
      content.style.maxHeight = content.scrollHeight + 'px';
    }
  }
  shouldComponentUpdate(nextProps, nextState) {
    const content = this.content;
    const open = nextState.open;
    if (content && open) {
      content.style.maxHeight = content.scrollHeight + 'px';
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.parentAccordionOpen && !this.props.parentAccordionOpen) {
      this.setState({ open: false })
      this.content.style.maxHeight = null;
    }
  }

  toggleConsentAll = () => {
    const consentAll = !this.state.consentAll;
    this.setState({ consentAll }, this.props.force);
  }
  toggleLiAll = () => {
    const liAll = !this.state.liAll;
    this.setState({ liAll }, this.props.force);
  }
  toggleDisclosure = () => {
    const disclosureAll = !this.state.disclosureAll;
    this.setState({ disclosureAll }, this.props.force);
  }
  toggleVendors = () => {
    const vendorsAll = !this.state.vendorsAll;
    this.setState({ vendorsAll }, this.props.force);
  }
  openLink = () => window.open(this.props.vendor.policyUrl, '_blank');
  render() {
    const {
      purpose,
      selected,
      settings,
      togglePurposeOrFeature,
      toggleText,
      toggleOffText,
      language,
      force,
      dev,
      parentAccordionOpen,
      isSpecialPurpose,
      isFeature,
    } = this.props;
    const {
      open,
      consentAll,
      liAll,
      disclosureAll,
      vendorsAll
    } = this.state;

    const viewAllText = makeText(Boolean(dev), settings, 'viewAllText', language);
    const viewLessText = makeText(Boolean(dev), settings, 'viewLessText', language);
    const otherText = makeText(Boolean(dev), settings, 'otherText', language);
    const otherLetter = makeText(Boolean(dev), settings, 'otherLetter', language);
    const customPurposesLetter = makeText(Boolean(dev), settings, 'customPurposesLetter', language);
    const purposeVendorTitle = makeText(Boolean(dev), settings, 'purposeVendorTitle', language);

    if (settings.alphabetizeVendors) {
      if (purpose.requiringConsentVendors) {
        purpose.requiringConsentVendors.sort((a, b) =>{
          if(a.name.toLowerCase() < b.name.toLowerCase()) { return -1; }
          if(a.name.toLowerCase() > b.name.toLowerCase()) { return 1; }
          return 0;
        });
      }
      if (purpose.legIntVendors) {
        purpose.legIntVendors.sort((a, b) =>{
          if(a.name.toLowerCase() < b.name.toLowerCase()) { return -1; }
          if(a.name.toLowerCase() > b.name.toLowerCase()) { return 1; }
          return 0;
        });
      }
      if (purpose.disclosureOnlyVendors) {
        purpose.disclosureOnlyVendors.sort((a, b) =>{
          if(a.name.toLowerCase() < b.name.toLowerCase()) { return -1; }
          if(a.name.toLowerCase() > b.name.toLowerCase()) { return 1; }
          return 0;
        });
      }
      if (purpose.vendors) {
        purpose.vendors.sort((a, b) =>{
          if(a.name.toLowerCase() < b.name.toLowerCase()) { return -1; }
          if(a.name.toLowerCase() > b.name.toLowerCase()) { return 1; }
          return 0;
        });
      }
    }

    const tabIndex = parentAccordionOpen ? 0 : -1;
    return (
      <div className="toggle-purpose">
        <div className="stack-row" style={{ position: 'relative' }}>
          <button
            tabIndex={tabIndex}
            className={open ? 'opener active' : 'opener'}
            onClick={this.toggleAccordion}
            onKeyDown={(e) => (e.keyCode == 13) && this.toggleAccordion()}
          >
            <span className="plusminus">{open ? '-' : '+'}</span>
            <span>{purpose.name}{purpose.type === 'CUSTOM' && <span className="legend-key inline">{customPurposesLetter}</span>}</span>
          </button>
          {togglePurposeOrFeature && (
            <Switch
              tabbable={tabIndex == 0}
              type={settings.toggleType}
              color={settings.toggleColor}
              colorActive={settings.toggleActiveColor}
              offColor={settings.toggleOffColor}
              offActiveColor={settings.toggleOffActiveColor}
              text={toggleText}
              offText={toggleOffText}
              toggle={togglePurposeOrFeature}
              child="purposes"
              vendors={selected === 'consent' ? purpose.requiringConsentVendors : purpose.legIntVendors}
              value={purpose}
              legInt={selected === 'li' ? true : false}
              checked={selected === 'li' ? purpose.legInt : purpose.active}
              tabbable={parentAccordionOpen}
              dev={dev}
              settings={settings}
              language={language}
            />
          )}
        </div>
        <div ref={c => this.content = c} className="main">
          <p className="sub-purpose-description">{formatDescription(purpose.description)}</p>
          {selected === 'consent' && (
            <div className="inner-main">
              <div className="legend" style={{ textAlign: 'left' }}>
                <span className="legend-key">
                  {otherLetter}
                </span>
                {otherText}
              </div>
              <div className="pv-title">{purposeVendorTitle}</div>
              {purpose.requiringConsentVendors.slice(0, consentAll ? purpose.requiringConsentVendors.length : 3)
                .map((v) => (
                  <Toggle
                    vendor={v}
                    key={v.vendorId}
                    language={language}
                    settings={settings}
                    force={force}
                    accordionOpen={open}
                    isSpecialPurpose={isSpecialPurpose}
                  />
                ))}
              {purpose.requiringConsentVendors.length > 3 && (
                <div
                  tabIndex={open ? 0 : -1}
                  className="view-all"
                  onClick={this.toggleConsentAll}
                  onKeyDown={e => e.keyCode == 13 && this.toggleConsentAll()}
                >
                  {consentAll ? viewLessText : viewAllText}
                </div>
              )}
            </div>
          )}
          {selected === 'li' && (
            <div className="inner-main">
              <div className="legend" style={{ textAlign: 'left' }}>
                <span className="legend-key">
                  {otherLetter}
                </span>
                {otherText}
              </div>
              <div className="pv-title">{purposeVendorTitle}</div>
              {purpose.legIntVendors.slice(0, liAll ? purpose.legIntVendors.length : 3)
                .map((v) => (
                  <Toggle
                    vendor={v}
                    key={v.vendorId}
                    language={language}
                    settings={settings}
                    force={force}
                    accordionOpen={open}
                  />
                ))}
              {purpose.legIntVendors.length > 3 && (
                <div
                  tabIndex={open ? 0 : -1}
                  className="view-all"
                  onClick={this.toggleLiAll}
                  onKeyDown={e => e.keyCode == 13 && this.toggleLiAll()}
                >
                  {liAll ? viewLessText : viewAllText}
                </div>
              )}
            </div>
          )}
          {selected === 'disclosure' && (
            <div className="inner-main">
              <div className="legend" style={{ textAlign: 'left' }}>
                <span className="legend-key">
                  {otherLetter}
                </span>
                {otherText}
              </div>
              <div className="pv-title">{purposeVendorTitle}</div>
              {purpose.disclosureOnlyVendors.slice(0, disclosureAll ? purpose.disclosureOnlyVendors.length : 3).map((v) => (
                <Toggle
                  vendor={v}
                  key={v.vendorId}
                  language={language}
                  settings={settings}
                  force={force}
                  accordionOpen={open}
                />
              ))}
              {purpose.disclosureOnlyVendors.length > 3 && (
                <div
                  tabIndex={open ? 0 : -1}
                  className="view-all"
                  onClick={this.toggleDisclosure}
                  onKeyDown={e => e.keyCode == 13 && this.toggleDisclosure()}
                >
                  {disclosureAll ? viewLessText : viewAllText}
                </div>
              )}
            </div>
          )}
          {selected === 'vendors' && (
            <div className="inner-main">
              {(!isSpecialPurpose && !isFeature) && (
                <div className="legend" style={{ textAlign: 'left' }}>
                  <span className="legend-key">
                    {otherLetter}
                  </span>
                  {otherText}
                </div>
              )}
              <div className="pv-title">{purposeVendorTitle}</div>
              {purpose.vendors.slice(0, vendorsAll ? purpose.vendors.length : 3).map((v) => (
                <Toggle
                  vendor={v}
                  key={v.vendorId}
                  language={language}
                  settings={settings}
                  force={force}
                  accordionOpen={open}
                  isSpecialPurposeOrFeature={isSpecialPurpose || isFeature}
                />
              ))}
              {purpose.vendors.length > 3 && (
                <div
                  tabIndex={open ? 0 : -1}
                  className="view-all"
                  onClick={this.toggleVendors}
                  onKeyDown={e => e.keyCode == 13 && this.toggleVendors()}
                >
                  {vendorsAll ? viewLessText : viewAllText}
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    );
  }
}